module.exports = __webpack_public_path__ + "static/img/892.d7cf03f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/892.jpg
// module id = aJ4r
// module chunks = 0